module.exports = __webpack_public_path__ + "img/noble-new-year.d4785cc9.png";